// @ts-check

import {
  referenceStatusIcon,
  referenceStatusVariant
} from '@/constants/references'
import { formatMoney } from '@spl-company-oy/core'
import * as _ from 'lodash-es'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

/**
 * @param {import('vue').Ref<ReferenceInterface>} reference
 */
export const useReference = (reference) => {
  const { t } = useI18n()

  const referenceStatus = computed(() => reference.value.status.toLowerCase())

  const referenceAmount = computed(() =>
    formatMoney(reference.value.amount ?? { amount: '0', currency: 'EUR' })
  )

  const statusIcon = computed(
    () => _.get(referenceStatusIcon, referenceStatus.value) ?? '$clock-outline'
  )

  const statusText = computed(() =>
    t(`references.${reference.value.type}.status.${referenceStatus.value}`)
  )

  const statusVariant = computed(
    () => _.get(referenceStatusVariant, referenceStatus.value) ?? 'primary'
  )

  return {
    referenceAmount,
    referenceStatus,
    statusIcon,
    statusText,
    statusVariant
  }
}

export default useReference
